// Project completion is a MANUAL status choice (firm decision, 2026-06): a
// project is Completed only when someone sets the status. Nothing is derived
// from dates. This is a DISPLAY/FILTER concept only — completed projects stay
// in the dataset and therefore in every total, chart and history calculation.
export const COMPLETED_STATUS = "Completed";

export const isCompleted = (p) => (p?.status || "") === COMPLETED_STATUS;

// A live project whose expected end date has passed — a quiet nudge to review
// the status. Never changes the status automatically.
export const isPastEndDate = (p, todayIso = new Date().toISOString().slice(0, 10)) => {
  if (isCompleted(p)) return false;
  const end = (p?.endDate || "").slice(0, 10);
  return !!end && end < todayIso;
};
